import React, { Component } from 'react';
import { connect } from 'react-redux';

class FilterButtons extends Component {

  render() {

    return (
      <section>
        {
          this.props.buttons.map((data) => {
            const selected = (data.selected) ? ' selected' : '';
            
            return (
              <div key={data.id} className={"filter-button" + selected} onClick={() => this.props.updateFilter(data)}>
                <svg aria-hidden="true" data-prefix="fas" data-icon={data.category} className="svg-inline--fa fa-cannabis fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox={data.viewbox}><path fill="#d3d7da" d={data.image}></path></svg>
                <p>{data.category}</p>
              </div>
            )
          })
        }
      </section>
    );
  }
}

const mapState = (state) => {

  return {
    buttons: state.influenceData.buttons,
  }
};

const mapDispatch = (dispatch) => {
  return {
    updateFilter: (data) => {
      dispatch({
        type: "INFLUENCE_UPDATE",
        category: data.category,
      });
    }
  }
}

export default connect(mapState, mapDispatch)(FilterButtons);



// WEBPACK FOOTER //
// ./src/components/Influence/Filter/FilterButtons/FilterButtons.js